<template>
<div class="content">
 <div class="top-bg-box">
   <div class="head-box left-justifying">
     <img class="head-box-img" :src="userInfo.avatar" alt="" />
     <div class="user-content-box">
        <div class="name" @click="vConsoleSet">{{userInfo.nickname}}</div>
       <!-- <div class="phone">15077054878</div> -->
     </div>
   </div>
   <div class="tool-box">
     <div class="tool-top-box justify-align">
       <div class="item-tool-item" @click="goBonus">
         <img :src="require('../../assets/'+appTheme+'/q_icon.png')" alt="" />
         <span>消费券</span>
       </div>
       <div class="item-tool-item" @click="goAddList">
         <img :src="require('../../assets/'+appTheme+'/user_add.png')" alt="" />
         <span>地址</span>
       </div>
<!--       <div class="item-tool-item" @click="clickHint">-->
<!--         <div class="msg">3</div>-->
<!--         <img src="../../assets/user_letter.png" alt="" />-->
<!--         <span>通知</span>-->
<!--       </div>-->
       <div class="item-tool-item" @click="goCollectGoods">
         <img :src="require('../../assets/'+appTheme+'/user_scj.png')" alt="" />
         <span>收藏夹</span>
       </div>
<!--       <div class="item-tool-item" @click="goWallet">-->
<!--         <img src="../../assets/user_qianbao.png" alt="" />-->
<!--         <span>钱包</span>-->
<!--       </div>-->
     </div>
   </div>
<!--   <div class="content-block">-->
<!--     <div class="item-block">-->
<!--       <span style="opacity: 0" @click="clickHint">0</span>-->
<!--       <div class="item-name">待消费</div>-->
<!--     </div>-->
<!--     <div class="item-block" @click="clickHint">-->
<!--       <span style="opacity: 0">0</span>-->
<!--       <div class="item-name">购物车</div>-->
<!--     </div>-->
<!--     <div class="item-block" @click="goBonus">-->
<!--       <span style="opacity: 0">1</span>-->
<!--       <div class="item-name">消费券</div>-->
<!--     </div>-->
<!--     <div class="item-block" @click="goCollectGoods">-->
<!--       <span style="opacity: 0">1</span>-->
<!--       <div class="item-name">收藏夹</div>-->
<!--     </div>-->
<!--   </div>-->
 </div>
  <div class="order-block bg-white" style="margin-top: -2.66667vw;">
    <div class="order-box">
      <div class="text-center pt-1 item-order" @click="goOrder(orders.status_0.type)">
        <img :src="orders.status_0.icon">
        <div>{{orders.status_0.text}}</div>
      </div>
      <div class="text-center pt-1 item-order" @click="goOrder(orders.status_1.type)">
        <img :src="orders.status_1.icon">
        <div>{{orders.status_1.text}}</div>
      </div>
      <div class="text-center pt-1 item-order" @click="goOrder(orders.status_2.type)">
        <img :src="orders.status_2.icon">
        <div>{{orders.status_2.text}}</div>
      </div>
      <div class="text-center pt-1 item-order" @click="goOrder(orders.status_3.type)">
        <img :src="orders.status_3.icon">
        <div>{{orders.status_3.text}}</div>
      </div>
      <div class="text-center pt-1 item-order" @click="goOrder(orders.status_4.type)">
        <img :src="orders.status_4.icon">
        <div>{{orders.status_4.text}}</div>
      </div>
    </div>
  </div>
  <div class="menu-box">
<!--    <div class="item-menu" @click="goUserBusiness">-->
<!--      <div class="item-menu-sec justify-align border">-->
<!--        <div class="left-justifying">-->
<!--          <img class="menu-icon" style="width: 6.13333vw;height: auto;margin-right: 0.66667vw" src="../../assets/shop_user_m.png" alt="">-->
<!--          精品商家中心-->
<!--        </div>-->
<!--        <img class="right-icon" src="../../assets/right_icon.png" alt="">-->
<!--      </div>-->
<!--    </div>-->

	<div class="item-menu" @click="goToOtherUrl('https://jpzs-zst.itos.cn/formBillApply')">
	      <div class="item-menu-sec justify-align border">
	        <div class="left-justifying" id="bill-apply">
	          <img class="menu-icon" :src="require('../../assets/'+appTheme+'/bill-apply.png')" alt="">
	          精品免押账期
	        </div>
	        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
	      </div>
	    </div>

    <div class="item-menu border" @click="goApplyFor">
      <div class="item-menu-sec justify-align">
        <div class="left-justifying">
          <img class="menu-icon menu-icon-sec" :src="require('../../assets/'+appTheme+'/xiyi.png')" alt="" />
          全球名优申请
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </div>
    <div class="item-menu border" @click="goApplyForGz">
      <div class="item-menu-sec justify-align">
        <div class="left-justifying">
          <img class="menu-icon menu-icon-sec" :src="require('../../assets/'+appTheme+'/shouquanshu.png')" alt="" />
          政府商标授权
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </div>
<!--    <div class="item-menu border" @click="goWalletRegister">-->
<!--      <div class="item-menu-sec justify-align">-->
<!--        <div class="left-justifying">-->
<!--          <img class="menu-icon menu-icon-sec" src="../../assets/user_qian.png" alt="">-->
<!--          企业钱包管理-->
<!--        </div>-->
<!--        <img class="right-icon" src="../../assets/right_icon.png" alt="">-->
<!--      </div>-->
<!--    </div>-->
    <div class="item-menu border" @click="goFastCode">
      <div class="item-menu-sec justify-align">
        <div class="left-justifying">
          <img class="menu-icon menu-icon-sec" src="../../assets/user_qrcode_icon.png" alt="">
          快码（收款码）
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </div>
    <div class="item-menu border">
      <div class="item-menu-sec justify-align" @click="isCheckPhone">
        <div class="justify-align" style="position: relative;width:100%;">
          <div class="left-justifying">
            <img class="menu-icon menu-icon-sec" style="margin-right: 0.66667vw;" :src="require('../../assets/'+appTheme+'/xcx_icon.png')" alt="">
            快送（近配送）
            <wx-open-launch-weapp id="launch-btn" :username="username" :path="pathUrl" ref="subscribeBtn">
              <!--            <script type="text/wxtag-template">-->
              <!--              <style>.btn {align-items: center;color:#282828;-->
              <!--              border: none; }</style>-->
              <!--              <div class="btn">银企跑腿小程序</div>-->
              <!--            </script>-->
              <script type="text/wxtag-template">
                <style>
                  .btn2 {
                    border: none;
                    position:absolute;
                    z-index:2;
                    opacity: 0;
                    left:0;top:0;
                    right:0;
                    bottom:0;
                    width:100%;
                    height:100%;
                  }
                </style>
                <button class="btn2"></button>
              </script>
            </wx-open-launch-weapp>
          </div>

          <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
        </div>

      </div>
    </div>

  </div>
  <div class="menu-box">
    <div class="item-menu" @click="goAgreement">
      <div class="item-menu-sec justify-align border">
        <div class="left-justifying">
          <img class="menu-icon" :src="require('../../assets/'+appTheme+'/xiyi.png')" alt="">
          平台申明协议
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </div>
    <div class="item-menu" @click="goContactUs">
      <div class="item-menu-sec justify-align border">
        <div class="left-justifying">
          <img class="menu-icon" :src="require('../../assets/'+appTheme+'/liwm.png')" alt="">
          欢迎联系我们
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </div>

  </div>
  <div class="menu-box">
    <div class="item-menu border" style="display: block;color: #282828;" @click="goCode">
      <div class="item-menu-sec justify-align">
        <div class="left-justifying">
          <img class="menu-icon menu-icon-sec" :src="require('../../assets/'+appTheme+'/shop_user_card.png')" alt="">
          中山通会员卡
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </div>
    <a class="item-menu border" style="display: block;color: #282828;" href="https://wechat.zstingche.cn/wechat/searchberth.html">
      <div class="item-menu-sec justify-align">
        <div class="left-justifying">
          <img class="menu-icon menu-icon-sec" :src="require('../../assets/'+appTheme+'/user_p.png')" alt="">
          中山停车空位
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </a>
    <a class="item-menu border" style="display: block;color: #282828;" href="https://weixin.zsyjjkw.com/wechat/wx_hcn-auth.html">
      <div class="item-menu-sec justify-align">
        <div class="left-justifying">
          <img class="menu-icon menu-icon-sec" :src="require('../../assets/'+appTheme+'/yy_user_icon.png')" alt="">
          中山医院医生
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </a>
    <a class="item-menu border" style="display: block;color: #282828;" href="https://u.interlib.cn/index.php?g=Mysql&m=Index&a=index&token=xqcpni1490770140">
      <div class="item-menu-sec justify-align">
        <div class="left-justifying">
          <img class="menu-icon menu-icon-sec" :src="require('../../assets/'+appTheme+'/shop_user_book.png')" alt="">
          中山图书借阅
        </div>
        <img class="right-icon" :src="require('../../assets/'+appTheme+'/right_icon.png')" alt="">
      </div>
    </a>
  </div>
<!--  <div @click="adgo" v-if="userInfo.id==2" style="text-align: center;font-size: 4.26667vw;margin-top: 2.66667vw;">ad</div>-->
  <div style="height: 25.33333vw;"></div>
</div>
</template>

<script>
import QS from 'qs'
import {getWechat} from "@/api/zhibo";
import store from "@/store";
let Base64 = require('js-base64').Base64
const jweixin = require('jweixin-module');
export default {
  name: 'User',
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      orders: {
        status_0: { text: '待付款', icon: require('@/assets/order1.png'), type: 0 },
        status_1: { text: '待收货', icon: require('@/assets/order2.png'), type: 2 },
        status_2: { text: '待评价', icon: require('@/assets/order3.png'), type: 4 },
        status_3: { text: '过期/退款', icon: require('@/assets/order4.png'), type: 4 },
        status_4: { text: '全部', icon: require('@/assets/order5.png'), type: 4 }
      },
      userInfo: '',
      vConsoleVal: 0,
      username: 'gh_806460f3110a', // gh_ 开头的原始小程序ID
      pathUrl: '/make_speed/router/router', // 一定要以 .html 结尾
    }
  },
  mounted(){
    window.addEventListener("pagehide", this.pageHide);
  },
  created() {
    // this.setToken();
    var userInfo = this.$store.state.userInfo
    if (userInfo == ''){
      this.getUser()
    } else {
      this.userInfo = userInfo
      this.$store.commit('setAddressInfo',''); // 清除掉缓存的地址
      this.$store.commit('setGoodsInfo',''); // 清除掉缓存的商品
      // console.log('userInfo',userInfo)
      this.wxSubscribe() // 初始化微信
    }

  },
  destroyed() {
      //移除事件处理程序
    window.removeEventListener("pagehide", this.pageHide);
    },
  methods: {
    routeNameToGo(routeName) {
      this.$router.push(routeName);
    },
    goToOtherUrl(url) {
      window.location.href = url
    },
    goCode(){ // 中山通会员
      // 获取存储的token的值  有的话 赋值 isLogin 为true 否则 false
      const terminalToken = localStorage.getItem('terminalToken')
      var accountOpenState = localStorage.getItem('accountOpenState')
      console.log('terminalToken', terminalToken)
      if (terminalToken != null){ // 非等于空
        var tokenInfo = JSON.parse(terminalToken)
        // 获取当前时间
        let nows = new Date().getTime();
        console.log('new',nows);

        if (nows - tokenInfo.startTime > tokenInfo.expires) {
          console.log('时间到期')
          localStorage.removeItem('terminalToken');
          localStorage.removeItem('accountOpenState');
          this.$router.push('/consumerLogin');
        } else { // 没到时间
          var TokenInfo = JSON.parse(terminalToken)
          var stateInfo = JSON.parse(accountOpenState)
          console.log('没到时间 ')
          var str= 'https://jpzs.itos.cn/Wechat/Member/index.html'
          var result = Base64.encode(str);
          console.log(result)
          var url = 'https://m.bte.group/jump/terminalToken/'+TokenInfo.value+'/accountOpenState/'+ stateInfo.value+'/returnUrl/'+result
          // console.log(url)
          window.location.href = url
        }
      } else {
        this.$router.push('/consumerLogin');
      }
    },
    //页面关闭或刷新时触发
     pageHide() {
       this.$store.commit("setWechatSignUrl", '');
    },
    isCheckPhone(){
      // 导入微信工具函数
      const { isWechat, checkWechatVersion, isMiniProgram } = require('@/utils/wechatUtils');
      
      if (!isWechat()) {
        console.log('非微信环境，跳过微信相关检查');
        return true;
      }
      
      const versionCheck = checkWechatVersion('8.0.8');
      if (!versionCheck.versionOk) {
        this.$toast(versionCheck.message);
        return false;
      }
      
      // 检查是否为小程序环境
      isMiniProgram().then(isMini => {
        if (isMini) {
          console.log('小程序webview访问');
          this.$toast('请移步全球灯云公众号访问');
        } else {
          console.log('微信浏览器环境，版本检查通过');
        }
      });
      
      return true;
    },
    compareVersion(v1, v2) { // 版本比较
      v1 = v1.split('.')
      v2 = v2.split('.')
      var len = Math.max(v1.length, v2.length)

      while (v1.length < len) {
        v1.push('0')
      }
      while (v2.length < len) {
        v2.push('0')
      }

      for (var i = 0; i < len; i++) {
        var num1 = parseInt(v1[i])
        var num2 = parseInt(v2[i])

        if (num1 > num2) {
          return 1
        } else if (num1 < num2) {
          return -1
        }
      }
      return 0
    },
    isWeixn(){
      // 使用统一的微信检测工具函数
      const { isWechat } = require('@/utils/wechatUtils');
      return isWechat();
    },
    wxSubscribe(){ // 初始化微信
      // 导入微信工具函数
      const { isWechat } = require('@/utils/wechatUtils');
      
      if (!isWechat()) {
        console.log('非微信环境，跳过微信初始化');
        return;
      }
      
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        console.log('ios')
      } else {
        console.log('安卓')
        pageUrl = location.href.split('#')[0] // encodeURIComponent
      }

      var data = {
        liveUrl: pageUrl//pageUrl
      }
      console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          var weChat = res.data
          console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['wx-open-launch-weapp'],
            openTagList: ["wx-open-launch-weapp"] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          //是否支持打开
          jweixin.checkJsApi({
            jsApiList: ['wx-open-launch-weapp'],
            success: function (res) {
              console.log(res)
            }
          });
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            console.log('ready')
          })

          const btn = this.$refs.subscribeBtn;
          if (btn) {
            btn.addEventListener('launch', function (e) {
              console.log('success');
            });
            btn.addEventListener('WeixinOpenTagsError', function (e) {
              console.error('fail',e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
            });
            btn.addEventListener('error', function (e) {
              console.log('fail', e.detail);
            });
          }
        } else {
          this.$toast(res.message)
        }
      })
    },
    clickHint(){
      this.$toast('暂未开放，敬请期待')
    },
    goUserBusiness(){
      // this.$router.push('/indexBusiness')
      this.$toast('暂未开放，敬请期待')
    },
    vConsoleSet() {
      this.vConsoleVal++
      if(this.vConsoleVal === 3) {
        this.$store.commit('setVconsole')
      }
    },
    goWalletRegister(){
      var url = 'https://gmssc.gnete.com/#/EnterpriseRegister?isFrom=gzh'
      window.location.href = url
    },
    goBonus(){
      this.$router.push('/discountCoupon');
    },
    goFastCode(){
      this.$router.push('/polyCode');
    },
    adgo(){
      // this.$router.push({path:'/materialList',query: {id:67}});
       // activityThemeSec
      var type= 'yearOfNanan'
      // var type= 'gift'
      // this.$router.push({name:'activityTheme',params: {type:type}});
      // this.$router.push({name:'payComeBack',params: {merOrderId:type}});
      // this.$router.push({path:'/activityTheme',query: {type:type}});
      var id = 1
      // this.$router.push('/shop/1') ;
      this.$router.push('factoryList') ;
      },
    clickGo(){
      this.$router.push('/paySucceed');
    },
    goApplyFor(){
      this.$router.push('/applyFor');
    },
    goApplyForGz(){
      // this.$router.push('/brandAuthorization');
      let url = 'https://jpzs-zst.itos.cn/brandAuthorization'
      window.open(url)
    },
    async getUser () {
      const res = await this.$Http.getInfo()
      if (res.code == 200){
        const info = res.data;
        this.userInfo = info;
        this.wxSubscribe() // 初始化微信
        console.log('res',res)
        this.$store.commit('setUserInfo', info)
      } else {
        this.$router.push('/');
      }
    },
   async goWallet(){
      var type =0 // 1钱包  0未开通钱包
      const res = await this.$Http.getInfo()
      if (res.code == 200){
        const info = res.data;
        this.userInfo = info;
        const wallet_id = res.data.wallet_id
        console.log(wallet_id)
        if (wallet_id != null){
          this.$router.push('/wallet');
        } else {
          this.$router.push('/openBurse');
        }

      } else {
        this.$router.push('/');
      }
      // if(type==0){
      //   // this.$router.push('/openBurse');
      //   this.$router.push('/myCard');
      // } else {
      //   this.$router.push('/wallet');
      // }

    },
    goAddList(){
      this.$router.push('/addressList');
    },
    setToken() {
      var token = 'Bearer 1|lQMa9L71V0A86jD3xcqBNI6yrvIEx2dTAkccpfdT'
      // localStorage.setItem('token',token)
    },
    goOrder(type){
      var type = type
      console.log(type)
      if (type==4){
        type = 'null'
      } else {
        type = type
      }
      this.$router.push({path:'/order',query: {type:type}})
    },
    goCollectGoods(){
      this.$router.push('/collectList');
    },
    goContactUs(){
      this.$router.push('/contactUs');
    },
    goAgreement(){
      this.$router.push('/xieYiList');
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  color: #282828;
}
.top-bg-box{
  width: 750px;
  //height: 445px;
  background: #FDD80D;
  .head-box{
    padding: 50px 24px 0 24px;
    .head-box-img{
      width: 124px;
      height: 124px;
      border-radius: 50%;background: #cccccc;
    }
    .user-content-box{
      margin-left: 50px;text-align: left;
    }
    .name{
      font-size: 46px;color: #282828;font-weight: 500;
    }
    .phone{
      background: rgba(255, 255, 255, 0.3);
      border-radius: 17px;font-size: 24px;color: #282828;
      margin-top: 10px;font-weight: 400;padding: 5px 15px;
    }
  }
  .tool-box{
    width: 650px;margin: 44px auto 0;background: #FFEA78;padding: 0 25px;
    border-radius: 15px;
    .item-tool-item{
      width: 25%;text-align: center;font-size: 28px;color: #282828;padding-top: 39px;
      //padding-bottom: 70px;
      padding-bottom: 50px;
      position: relative;
      img{
        width: 66px;height: auto;display: block;margin: 0 auto;
      }
      .msg{
        width: 30px;
        height: 30px;line-height: 30px;
        background: #F23926;
        border-radius: 50%;font-size: 18px;color: #ffffff;right: 40px;position: absolute;top: 40px;
      }
    }
  }
}
.content-block{
  margin-top: -50px;
  background-image: url("../../assets/wo_bg.png");background-size: 100% 100%;height: 187px;
  .item-block{
    display: inline-block;
    width: 25%;text-align: center;padding-top:65px;
    span{
      font-weight: bold;display: inline-block;margin-bottom: 10px;font-size: 30px;
    }
    .item-name{
      font-size: 28px;
    }
  }
}
.order-block{
  padding: 20px 20px;background: #fff;border-radius: 10px;color: #000000;font-size: 28px;
}
.order-block .order-box .item-order{
  position: relative;
  display: inline-block;
  width: 20%;
  text-align: center;
  padding: 5px 0 10px;font-size: 27px;
}
.order-block .order-box .item-order img {
  width: 76px;height: 76px;display: inline-block;margin-bottom: 10px;
}
.menu-box{
  margin-top: 30px;
  font-size: 30px;background: #fff;
  .menu-icon{
    width: 50px;height: auto;margin-right: 10px;
  }
  //.menu-icon-sec{
  //  width: 58px;
  //}
  .right-icon{
    width: 14px;height: auto;
  }
  .item-menu{
    margin: 0 33px;
  }
  .item-menu-sec{
    padding: 20px 0;
  }
  .border{
    border-bottom: 1px solid #E6E6E6;
  }
}
#launch-btn{
  width: 100%;
  height: 100%;
  position: absolute;left: 0;top: 0;z-index: 888;
}
#bill-apply {
  color: red;
}
</style>
